<template src="./Country.html"></template>

<script>
import topMenu from '@/components/brand/components/topMenu';
import brandSelect from '@/components/components/BrandSelect';
import {createNamespacedHelpers} from 'vuex';

const {mapGetters, mapActions} = createNamespacedHelpers('brand/country')

export default {
  name: "brandCountry",
  components: {
    topMenu,
    brandSelect
  },
  data() {
    return {
      brandId: this.$route.params.id,
      showOverlay: false,
      fieldsList: [
        {
          key: 'country',
          label: 'Страна',
          sortable: false
        },
        {
          key: 'frequency',
          label: 'Частотность',
          sortable: true
        },
        {
          key: 'demandForecast',
          label: 'Пр. Спрос',
          sortable: true
        },
        {
          key: 'applications',
          label: 'Число запросов',
          sortable: true
        },
        {
          key: 'conversion',
          label: 'Конверсия',
          sortable: true
        },
        {
          key: 'averageCheck',
          label: 'Средний чек',
          sortable: true
        },
        {
          key: 'MPR',
          label: 'MPR',
          sortable: true
        },
      ],
      currentPage: 1,
      periodOptions: [
          {
            value: 1,
            text: 'Месяц'
          },
          {
            value: 2,
            text: '3 Месяца'
          },
          {
            value: 3,
            text: '6 Месяца'
          },
          {
            value: 4,
            text: '1 Год'
          },
          {
            value: 5,
            text: 'Все время'
          },

      ],
      period: 1
    }
  },
  methods: {
    ...mapActions([
      'GET_DATA',
    ]),
    brandsChange: function (brand) {
      if (brand == null || (this.CURRENT_BRAND != null && this.CURRENT_BRAND.id == brand.id)) {
        return
      }
      this.brandId = brand.saleId.toString()
      this.$store.commit('brand/country/CURRENT_BRAND', brand);
      this.GET_DATA({id: this.brandId, th: this});
    },
    initPageSize: function () {
      let winHeight = window.innerHeight;
      winHeight = Math.round((winHeight - 205) / 24.5);
      this.$store.commit('brand/country/PER_PAGE', winHeight);
      this.currentPage = 1;
    },
  },
  computed: {
    ...mapGetters([
      'DATA_BY_COUNTRY',
      'CURRENT_PAGE',
      'TOTAL_ROWS',
      'PER_PAGE',
      'CURRENT_BRAND',
      'REGIONS',
      'PERIOD',
    ]),
    getDataByRegion: function () {
      if (this.DATA_BY_COUNTRY.length == 0) {
        return []
      }
      let rowTemplate = {
        country: {name: '&nbsp;'},
        frequency: '__',
        applications: '__',
        conversion: '__',
        averageCheck: '__',
        MPR: '__',
        demandForecast: '__',
      }
      let totalSum = 0
      let buf = []
      let regionFrequencySum
      for (let key in this.REGIONS) {
        regionFrequencySum = 0
        let regionName = this.REGIONS[key]
        let rowBuf = Object.assign({}, rowTemplate)
        // push empty row between regions
        buf.push(rowBuf)
        // push region name
        rowBuf = Object.assign({}, rowTemplate)
        rowBuf.country = {name: (regionName == null ? 'Без региона' : regionName)}
        buf.push(rowBuf)
        let regionIndex = buf.length - 1
        for(let key2 in this.DATA_BY_COUNTRY) {
          let data = this.DATA_BY_COUNTRY[key2]
          if (
              (regionName == null && data.country.region == null)
              || (data.country.region != null && regionName === data.country.region.name)
          ) {
            buf.push(data)
            if (data.frequency != null) {
              regionFrequencySum += data.frequency
              totalSum += data.frequency
            }
          }
        }
        buf[regionIndex].frequency = regionFrequencySum
      }
      // set total sum
      buf[0].frequency = totalSum

      return buf
    }
  },
  watch: {
    currentPage(newVal) {
      this.$store.commit('brand/country/CURRENT_PAGE', newVal);
    },
    period(newVal) {
      this.$store.commit('brand/country/PERIOD', newVal);
      this.GET_DATA({id: this.brandId, th: this});
    }
  },
  mounted() {
    this.initPageSize();
    if (this.$store.getters.getAllowSection.indexOf('brand') === -1) {
      this.$router.push({name: 'permissionDenied'});
      return;
    }
  },
  created() {
    if (this.DATA_BY_COUNTRY.length == 0 || this.CURRENT_BRAND.id != this.brandId) {
      this.GET_DATA({id: this.brandId, th: this});
    }
  }
}
</script>

<style scoped>
.region-row {
  font-weight: bold;
}
</style>

<style>

</style>